import { Stack } from '@mui/material'
import { ArrowDownIcon, ArrowRightIcon, ArrowUpIcon } from '@phosphor-icons/react'
import { Percentage, tokens } from 'ComponentLibrary'
import { TextWithEllipsis, Typography } from 'ComponentLibrary/src/piazza/text'

type PercentageTrendProps = {
    percentage?: number
    variant?: 'textS' | 'textXS'
    locale?: string
}

export function PercentageTrend({ percentage, variant = 'textS', locale }: PercentageTrendProps) {
    const text = percentage !== undefined ? new Percentage(percentage).format({ withSign: true, numberOfDigits: 1, locale }) : undefined
    return (
        <Stack direction="row" gap={tokens.SizingSpacing075} alignItems="center" sx={{ minWidth: 0 }}>
            {text && percentage !== undefined ? (
                <>
                    {percentage > 0 ? (
                        <ArrowUpIcon weight="bold" size={tokens.SizingIconS} color={tokens.ColorIconPositive} />
                    ) : percentage < 0 ? (
                        <ArrowDownIcon weight="bold" size={tokens.SizingIconS} color={tokens.ColorIconDanger} />
                    ) : (
                        <ArrowRightIcon weight="bold" size={tokens.SizingIconS} color={tokens.ColorIconInformative} />
                    )}
                    <TextWithEllipsis
                        typographyProps={{
                            variant,
                            color:
                                percentage > 0
                                    ? tokens.ColorTextPositiveSubtle
                                    : percentage < 0
                                      ? tokens.ColorTextDangerSubtle
                                      : tokens.ColorTextInformativeSubtle,
                        }}
                        tooltipText={text}
                    >
                        {text}
                    </TextWithEllipsis>
                </>
            ) : (
                <Typography variant={variant} color={tokens.ColorTextBold}>
                    -
                </Typography>
            )}
        </Stack>
    )
}
